/*
 * theme-custom.js
 *
 * These twelve blocks were inline <script> tags at the bottom of layout/theme.liquid —
 * about 15.8KB of JavaScript re-sent with every page and impossible to cache separately.
 * They are concatenated here verbatim, in their original order, and loaded once with defer.
 *
 * Order is preserved deliberately. The apparent duplicate declarations between blocks
 * (STORAGE_KEY, getWishlist, header, searchInput, list) are all inside IIFEs or
 * DOMContentLoaded callbacks, so they stay function-scoped and do not collide.
 *
 * Two functions are intentionally left at top level because markup calls them directly:
 *   triggerCustomCart()  — snippets/header-sidebar.liquid onclick
 *   triggerSearch()      — snippets/header-sidebar.liquid onclick (also set on window)
 * Deferred scripts run before DOMContentLoaded, so both exist well before a user can click.
 *
 * None of this code contained Liquid, which is why it can live in a static asset.
 */

/* ---------------------------------------------------------------------------
   Block 1 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var STORAGE_KEY = 'collsh_wishlist';

  /* ---- localStorage helpers ---- */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }
  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1; /* true = just added */
  }

  /* ---- Heart visual state ---- */
  /* ---- Heart visual state — applies to ONE button ---- */
  function setHeartFilled(btn, filled) {
    var svg = btn.querySelector('svg');
    if (!svg) return;
    svg.style.fill = filled ? '#89B2C4' : 'none';
    svg.style.stroke = filled ? '#89B2C4' : '#1E1E1E';
    svg.querySelectorAll('path').forEach(function (p) {
      p.style.fill = filled ? '#89B2C4' : '';
    });
    btn.setAttribute('data-wishlisted', filled ? 'true' : 'false');
    btn.setAttribute('aria-label', filled ? 'Remove from wishlist' : 'Add to wishlist');
  }

  /* ---- Sync ALL buttons on page that share the same handle ---- */
  function syncAllButtons(handle, filled) {
    /* collsh grid hearts — match via sibling quickbtn */
    document.querySelectorAll('.collsh__card').forEach(function (card) {
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      var heart = card.querySelector('.collsh__card-heart');
      if (!qBtn || !heart) return;
      if (qBtn.getAttribute('data-handle') === handle) {
        setHeartFilled(heart, filled);
      }
    });

    /* collsh__card-heart with direct data-handle */
    document.querySelectorAll('.collsh__card-heart[data-handle]').forEach(function (btn) {
      if (btn.getAttribute('data-handle') === handle) {
        setHeartFilled(btn, filled);
      }
    });

    /* Product page .whishsh buttons */
    document.querySelectorAll('.whishsh[data-handle]').forEach(function (btn) {
      if (btn.getAttribute('data-handle') === handle) {
        setHeartFilled(btn, filled);
      }
    });
  }

  /* ---- On page load: fill hearts for already-wishlisted products ---- */
  function initHearts() {
    /* collsh grid cards */
    document.querySelectorAll('.collsh__card').forEach(function (card) {
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      var heart = card.querySelector('.collsh__card-heart');
      if (!qBtn || !heart) return;
      var handle = qBtn.getAttribute('data-handle');
      if (!handle) return;
      setHeartFilled(heart, isWishlisted(handle));
    });

    /* Product page button */
    document.querySelectorAll('.whishsh').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      setHeartFilled(btn, isWishlisted(handle));
    });
  }

  /* ---- Heart click: toggle + animate ---- */
  /* ---- Unified click handler for ALL wishlist buttons ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.collsh__card-heart, .whishsh');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    /* Get handle — direct on button OR via sibling quickbtn */
    var handle = btn.getAttribute('data-handle');
    if (!handle) {
      var card = btn.closest('.collsh__card');
      if (!card) return;
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      if (!qBtn) return;
      handle = qBtn.getAttribute('data-handle');
    }
    if (!handle) return;

    var nowAdded = toggleWishlist(handle);

    /* Sync every button on the page that has this handle */
    syncAllButtons(handle, nowAdded);

    document.dispatchEvent(new CustomEvent('wishlist:updated'));

    /* Bounce animation on the clicked button only */
    btn.style.transform = 'scale(1.35)';
    setTimeout(function () {
      btn.style.transform = '';
    }, 200);
  });

  /* ---- Init on DOM ready ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHearts);
  } else {
    initHearts();
  }

  /* ---- Re-init if Shopify section is reloaded in theme editor ---- */
  document.addEventListener('shopify:section:load', initHearts);
})();

/* ---------------------------------------------------------------------------
   Block 2 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('click', function (e) {
  const pill = e.target.closest('.mainp-pill-btn');

  if (!pill) return;

  const notifyDiv = document.querySelector('.notifysh.sd');

  if (pill.classList.contains('mainp-pill-unavailable')) {
    notifyDiv?.classList.add('active');
  } else {
    notifyDiv?.classList.remove('active');
  }
});

/* ---------------------------------------------------------------------------
   Block 3 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var STORAGE_KEY = 'collsh_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function updateWishlistHeaderDot() {
    var list = getWishlist();
    var dot = document.querySelector('.whislist_icon_header .wishlist-dot');

    if (!dot) return;

    if (list && list.length > 0) {
      dot.style.display = 'block';
    } else {
      dot.style.display = 'none';
    }
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistHeaderDot);
  } else {
    updateWishlistHeaderDot();
  }

  // Listen for same-tab updates
  document.addEventListener('wishlist:updated', function () {
    updateWishlistHeaderDot();
  });

  // Listen for other-tab updates
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      updateWishlistHeaderDot();
    }
  });
})();

/* ---------------------------------------------------------------------------
   Block 4 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  function openPrestigeCartDrawer() {
    // ✅ Your theme's actual working method
    const realDrawer = document.querySelector('cart-drawer');
    if (realDrawer) {
      realDrawer.setAttribute('open', '');
      realDrawer.style.display = 'block';
    }

    // Method 1 – Modern Prestige Versions
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Method 2 – Variation used by some builds
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));

    // Method 3 – Fallback drawer open()
    const drawer = document.querySelector('cart-drawer, .cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  // Make globally accessible (important for ATC scripts)
  window.openPrestigeCartDrawer = openPrestigeCartDrawer;
});

/* ---------------------------------------------------------------------------
   Block 5 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header.color-scheme.color-scheme--scheme-2');

  if (header) {
    header.addEventListener('mouseenter', function () {
      header.classList.add('hover_head');
    });

    header.addEventListener('mouseleave', function () {
      header.classList.remove('hover_head');
    });
  }
});

/* ---------------------------------------------------------------------------
   Block 6 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
function triggerCustomCart() {
  const cartTrigger = document.getElementById('custom-cart-trigger');

  if (cartTrigger) {
    console.log('✅ #custom-cart-trigger found');
    cartTrigger.click();
    console.log('🛒 Triggered click on #custom-cart-trigger');
  } else {
    console.log('❌ #custom-cart-trigger NOT found');
  }
}

/* ---------------------------------------------------------------------------
   Block 7 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
(function () {
  const initScrollWatch = () => {
    window.addEventListener('scroll', () => {
      const el = document.getElementById('snize-instant-search-results');
      if (el) {
        el.classList.toggle('scrollsh', window.pageYOffset > 0);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollWatch);
  } else {
    initScrollWatch(); // DOM is already ready
  }
})();

/* ---------------------------------------------------------------------------
   Block 8 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
(function () {
  // Searchanise's own "Add to cart" button (added via the Searchanise app) doesn't
  // close the instant search panel after adding, so it overlaps the Rebuy cart drawer.
  // Watch every /cart/add call — via fetch AND via XHR (Searchanise's own add-to-cart
  // call is jQuery/XHR-based, not fetch, confirmed by inspecting the actual network
  // request it fires) — and close the search panel if it's open, regardless of what
  // triggered the add.
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1) {
        promise.then(function (response) {
          if (response && response.ok) closeSnizeSearchPanel();
        }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };

  var origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.__isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    } catch (e) {}
    return origXhrOpen.apply(this, arguments);
  };

  var origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) closeSnizeSearchPanel();
      });
    }
    return origXhrSend.apply(this, arguments);
  };

  function closeSnizeSearchPanel() {
    if (!document.body.classList.contains('snize-instant-widget-is-open')) return;
    var closeBtn = document.querySelector('.snize-close-button');
    if (closeBtn) {
      closeBtn.click();
    } else {
      document.body.classList.remove('snize-instant-widget-is-open');
      var results = document.getElementById('snize-instant-search-results');
      if (results) results.style.setProperty('display', 'none', 'important');
    }
  }
})();

/* ---------------------------------------------------------------------------
   Block 9 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  function getHeader() {
    return document.querySelector('.header') || document.querySelector('header');
  }

  function update() {
    const body = document.body;
    const header = getHeader();

    if (!header) {
      console.log('Header not found yet');
      return;
    }

    if (body.classList.contains('snize-instant-widget-is-open')) {
      header.classList.add('hover_headd');
    } else {
      header.classList.remove('hover_headd');
    }
  }

  // initial run (with retry in case header loads late)
  const interval = setInterval(() => {
    update();
    if (getHeader()) clearInterval(interval);
  }, 300);

  // observe body class changes
  const observer = new MutationObserver(update);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

/* ---------------------------------------------------------------------------
   Block 10 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  function triggerSearch() {
    const searchInput = document.querySelector('.header-search__input');
    if (!searchInput) return;

    searchInput.focus();
    searchInput.click();
    searchInput.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    searchInput.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  window.triggerSearch = triggerSearch;

  // ✅ Flag to track if search input was the last clicked
  window._searchInputWasClicked = false;

  const searchInput = document.querySelector('.header-search__input');
  if (searchInput) {
    searchInput.addEventListener('click', function () {
      window._searchInputWasClicked = true;
    });
  }
});

/* ---------------------------------------------------------------------------
   Block 11 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
function openPrestigeMobileMenu() {
  var sidebar = document.querySelector('x-sidebar-nav, nav-sidebar, sidebar-drawer');
  if (sidebar && typeof sidebar.open === 'function') {
    sidebar.open();
    return;
  }
  var hamburger =
    document.querySelector('.header__hamburger button') ||
    document.querySelector('[data-action="open-nav"]') ||
    document.querySelector('.header__icon--menu') ||
    document.querySelector('button[aria-label*="menu" i]') ||
    document.querySelector('button[aria-label*="navigation" i]') ||
    document.querySelector('.js-sidebar-toggle') ||
    document.querySelector('[aria-controls*="sidebar"]');
  if (hamburger) {
    hamburger.click();
  } else {
    console.warn('Prestige: could not find the mobile menu toggle button.');
  }
}

document.addEventListener('click', function (e) {
  if (e.target.closest('.snize-close-button')) {
    // ✅ Only open mobile menu if search input was previously clicked
    if (window._searchInputWasClicked) {
      openPrestigeMobileMenu();
      window._searchInputWasClicked = false; // reset after use
    }
  }
});

/* ---------------------------------------------------------------------------
   Block 12 of 12 — extracted verbatim from layout/theme.liquid
   --------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');

  if (!header) return;

  const path = window.location.pathname;

  // Homepage
  if (path === '/' || path === '/?') {
    header.classList.add('homepagesh');
  }
  // Collection pages (/collections/…)
  else if (path.startsWith('/collections')) {
    header.classList.add('collectionspagesh');
  }
  // Product pages (/products/…)
  else if (path.startsWith('/products')) {
    header.classList.add('productpagesh');
  }
});


/* ------------------------------------------------------------------------------------------
   Sold out product cards link through to the product page.

   The card button is a quick-add for in-stock products, but for a sold out one it now reads
   "Notify me when in stock" and has to take the customer somewhere they can actually do that.
   The product page carries the notify form.

   The destination is read from the card's own product link rather than rebuilt from a handle,
   so market and locale URL prefixes are preserved.
   ------------------------------------------------------------------------------------------ */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.collsh__card-quickbtn.is-sold-out');
  if (!button) return;

  var card = button.closest('.collsh__card');
  var link = card && card.querySelector('a.collsh__card-img-scroller, a.collsh__card-title');
  if (!link || !link.getAttribute('href')) return;

  // Stop the quick-add handlers on the same button from also firing.
  event.preventDefault();
  event.stopPropagation();
  window.location.href = link.href;
}, true);
